import React from 'react';
import { Hero } from './components/sections/Hero';
import { ProductFacts } from './components/sections/ProductFacts';
import { PlanningProblem } from './components/sections/PlanningProblem';
import { CompleteSystem } from './components/sections/CompleteSystem';
import { TrainingBlocks } from './components/sections/TrainingBlocks';
import { PagePreview } from './components/sections/PagePreview';
import { WorkloadSystem } from './components/sections/WorkloadSystem';
import { Bonuses } from './components/sections/Bonuses';
import { PrimaryOffer } from './components/sections/PrimaryOffer';
import { Guarantee } from './components/sections/Guarantee';
import { Faq } from './components/sections/Faq';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { SiteFooter } from './components/sections/SiteFooter';
import { StickyMobileCta } from './components/sections/StickyMobileCta';
import { PurchaseNotification } from './components/sections/PurchaseNotification';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="min-h-full w-full overflow-x-hidden bg-onyx" data-id="element-0" data-mp="3ml12h5fg3ihf">
      <Hero data-id="element-1" data-mp="3mj6jvxrnc2gi" />
      <main data-id="element-2" data-mp="3rc9i4j7dc031">
        <ProductFacts data-id="element-3" data-mp="3rbrayrj641gc" />
        <PlanningProblem data-id="element-4" data-mp="3rdatypw7kqlt" />
        <CompleteSystem data-id="element-5" data-mp="3rd18nfm3z7mg" />
        <TrainingBlocks data-id="element-6" data-mp="5yimri0b7dt" />
        {/* Hidden until real sample pages are added in data/samplePages.ts */}
        <PagePreview data-id="element-7" data-mp="2zld0z6e9z99y" />
        <WorkloadSystem data-id="element-8" data-mp="2zlv7qwykd5w4" />
        <Bonuses data-id="element-9" data-mp="2zmo3z3zwcd00" />
        {/* Urgency block omitted: no real promotion deadline supplied. */}
        <PrimaryOffer data-id="element-10" data-mp="33nghwajpr62m" />
        {/* Testimonials omitted until real customer reviews are supplied. */}
        <Guarantee data-id="element-11" data-mp="38k6ugnwb7jja" />
        <Faq data-id="element-12" data-mp="38nuqbtp88i16" />
        <BeforeAfter data-id="element-13" data-mp="3dkuv81acbeqp" />
      </main>
      <SiteFooter data-id="element-14" data-mp="3dl4kfmnk9hvc" />
      <StickyMobileCta data-id="element-15" data-mp="3dlnt0crbmtwp" />
      <PurchaseNotification data-id="element-16" data-mp="3dirtwl3qlz6o" />
    </div>;
}